module.exports = __webpack_public_path__ + "img/vertical_3_5_8023.34894d7e.png";